"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var BRANDING_ENDPOINT = 'branding/v1/branding';
var COMPANY_INFO_ENDPOINT = 'accountdashboard/v1/companyinfo';

var portalId = _hubspot.default.get();

var BrandingAPI =
/*#__PURE__*/
function () {
  function BrandingAPI() {
    (0, _classCallCheck2.default)(this, BrandingAPI);
  }

  (0, _createClass2.default)(BrandingAPI, null, [{
    key: "getBranding",
    value: function getBranding() {
      return _apiClient.default.get(BRANDING_ENDPOINT + "/" + portalId + "/get-or-default");
    }
  }, {
    key: "createOrUpdateBranding",
    value: function createOrUpdateBranding(data) {
      return _apiClient.default.put(BRANDING_ENDPOINT + "/" + portalId, {
        data: data
      });
    }
  }, {
    key: "getCompanyInfo",
    value: function getCompanyInfo() {
      return _apiClient.default.get(COMPANY_INFO_ENDPOINT);
    }
  }]);
  return BrandingAPI;
}();

exports.default = BrandingAPI;
module.exports = exports.default;